import { all } from "redux-saga/effects";

import { assetWatchers } from "./assetSaga";
import { authWatchers } from "./authSaga";
import { companiesWatchers } from "./companiesSaga";
import { deviceWatchers } from "./deviceSaga";
import { gatewayWatchers } from "./gatewaySaga";
import { incidentWatchers } from "./incidentsSaga";
import { notificationSettingsWatchers } from "./notificationSettingsSaga";
import { portfolioWatchers } from "./portfolioSaga";
import { reportWatchers } from "./reportSaga";
import { userWatchers } from "./userSaga";

export function* rootSaga() {
  yield all([
    ...assetWatchers,
    ...authWatchers,
    ...companiesWatchers,
    ...deviceWatchers,
    ...gatewayWatchers,
    ...incidentWatchers,
    ...notificationSettingsWatchers,
    ...portfolioWatchers,
    ...reportWatchers,
    ...userWatchers,
  ]);
}
